import { createClient } from '@supabase/supabase-js';

// Credenciales inyectadas automáticamente desde el entorno
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn('Supabase: Faltan variables de entorno. Asegúrate de conectar el proyecto.');
}

// Exportamos el cliente para usarlo en toda la aplicación
export const supabase = createClient(
  SUPABASE_URL || 'https://qdwozdxssusodggqqoqu.supabase.co', 
  SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFkd296ZHhzc3Vzb2RnZ3Fxb3F1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4ODg5NjEsImV4cCI6MjA4OTQ2NDk2MX0.LyQzd_Faf1M_QW21Q357qk3XVIUSNSBFtqMsDEO5FrI'
);